// The client link: browser ⇄ Go gateway ⇄ game server, binary protobuf over one WebSocket (design 4 §3.1).
// The game server builds every ServerMessage; the gateway forwards the bytes without decoding the body.

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file mj/protocol/v1/protocol.proto (package mj.protocol.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Action, ActionType, Event, GameEnd, HandEnd, HandSlots, HandStart, Player, RulesRef, Table } from "../../record/v1/record_pb";
import { file_mj_record_v1_record } from "../../record/v1/record_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mj/protocol/v1/protocol.proto.
 */
export const file_mj_protocol_v1_protocol: GenFile = /*@__PURE__*/
  fileDesc("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", [file_mj_record_v1_record]);

/**
 * @generated from message mj.protocol.v1.ClientMessage
 */
export type ClientMessage = Message<"mj.protocol.v1.ClientMessage"> & {
  /**
   * @generated from field: uint32 protocol_version = 1;
   */
  protocolVersion: number;

  /**
   * @generated from oneof mj.protocol.v1.ClientMessage.body
   */
  body: {
    /**
     * on every new connection
     *
     * @generated from field: mj.protocol.v1.Hello hello = 10;
     */
    value: Hello;
    case: "hello";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Nonce nonce = 11;
     */
    value: Nonce;
    case: "nonce";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Act act = 12;
     */
    value: Act;
    case: "act";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Ping ping = 13;
     */
    value: Ping;
    case: "ping";
  } | {
    /**
     * private tables only; a table option decides whether the table ends or plays on
     *
     * @generated from field: mj.protocol.v1.Leave leave = 14;
     */
    value: Leave;
    case: "leave";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Reading reading = 15;
     */
    value: Reading;
    case: "reading";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Press press = 16;
     */
    value: Press;
    case: "press";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mj.protocol.v1.ClientMessage.
 * Use `create(ClientMessageSchema)` to create a new message.
 */
export const ClientMessageSchema: GenMessage<ClientMessage> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 0);

/**
 * A button pressed with nothing behind it, at a table without assists (design 14 §6.6): a call or a win on someone
 * else's tile while its window is open, or a win, kan or riichi on the seat's own turn. Anywhere else it does nothing.
 *
 * @generated from message mj.protocol.v1.Press
 */
export type Press = Message<"mj.protocol.v1.Press"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: mj.record.v1.ActionType action = 2;
   */
  action: ActionType;

  /**
   * the seq of the last event the seat had seen: a press overtaken by a later one does nothing (0: not said)
   *
   * @generated from field: uint32 seen_seq = 3;
   */
  seenSeq: number;
};

/**
 * Describes the message mj.protocol.v1.Press.
 * Use `create(PressSchema)` to create a new message.
 */
export const PressSchema: GenMessage<Press> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 1);

/**
 * The seat is reading a hand's result (owner, 2026-10-14): sent as the result shows, then with done when the
 * player closes it. The next hand waits for every connected seat reading the result to be done, at most 15 s
 * after the hand's end; with nobody reading (bots, absent seats, clients that do not say), the fixed gap.
 *
 * @generated from message mj.protocol.v1.Reading
 */
export type Reading = Message<"mj.protocol.v1.Reading"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: uint32 hand_index = 2;
   */
  handIndex: number;

  /**
   * @generated from field: bool done = 3;
   */
  done: boolean;
};

/**
 * Describes the message mj.protocol.v1.Reading.
 * Use `create(ReadingSchema)` to create a new message.
 */
export const ReadingSchema: GenMessage<Reading> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 2);

/**
 * @generated from message mj.protocol.v1.ServerMessage
 */
export type ServerMessage = Message<"mj.protocol.v1.ServerMessage"> & {
  /**
   * @generated from field: uint32 protocol_version = 1;
   */
  protocolVersion: number;

  /**
   * @generated from field: uint64 server_time_ms = 2;
   */
  serverTimeMs: bigint;

  /**
   * @generated from oneof mj.protocol.v1.ServerMessage.body
   */
  body: {
    /**
     * @generated from field: mj.protocol.v1.Welcome welcome = 10;
     */
    value: Welcome;
    case: "welcome";
  } | {
    /**
     * @generated from field: mj.protocol.v1.TableAssigned table_assigned = 11;
     */
    value: TableAssigned;
    case: "tableAssigned";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Commitment commitment = 12;
     */
    value: Commitment;
    case: "commitment";
  } | {
    /**
     * @generated from field: mj.protocol.v1.NonceReceipt nonce_receipt = 13;
     */
    value: NonceReceipt;
    case: "nonceReceipt";
  } | {
    /**
     * @generated from field: mj.protocol.v1.GameStart game_start = 14;
     */
    value: GameStart;
    case: "gameStart";
  } | {
    /**
     * @generated from field: mj.protocol.v1.HandStartView hand_start = 15;
     */
    value: HandStartView;
    case: "handStart";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Events events = 16;
     */
    value: Events;
    case: "events";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Prompt prompt = 17;
     */
    value: Prompt;
    case: "prompt";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Ack ack = 18;
     */
    value: Ack;
    case: "ack";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Clock clock = 19;
     */
    value: Clock;
    case: "clock";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Connection connection = 20;
     */
    value: Connection;
    case: "connection";
  } | {
    /**
     * @generated from field: mj.protocol.v1.HandEndView hand_end = 21;
     */
    value: HandEndView;
    case: "handEnd";
  } | {
    /**
     * @generated from field: mj.protocol.v1.GameEndView game_end = 22;
     */
    value: GameEndView;
    case: "gameEnd";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Resync resync = 23;
     */
    value: Resync;
    case: "resync";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Error error = 24;
     */
    value: Error;
    case: "error";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Pong pong = 25;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * @generated from field: mj.protocol.v1.Aids aids = 26;
     */
    value: Aids;
    case: "aids";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mj.protocol.v1.ServerMessage.
 * Use `create(ServerMessageSchema)` to create a new message.
 */
export const ServerMessageSchema: GenMessage<ServerMessage> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 3);

/**
 * The play aids of unranked tables (design 8 item 2): the seat's own waits and furiten, sent to that seat
 * only, when they change. Ranked tables send none (design 8 P4, M5).
 *
 * @generated from message mj.protocol.v1.Aids
 */
export type Aids = Message<"mj.protocol.v1.Aids"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * tile kinds (0..33) completing the hand as of the seat's last discard
   *
   * @generated from field: repeated uint32 waits = 2;
   */
  waits: number[];

  /**
   * @generated from field: bool furiten = 3;
   */
  furiten: boolean;

  /**
   * Of those waits, the ones that would not win the hand as it stands: no yaku at all, or none on a discard without riichi.
   *
   * @generated from field: repeated uint32 no_yaku = 4;
   */
  noYaku: number[];

  /**
   * @generated from field: repeated uint32 no_ron = 5;
   */
  noRon: number[];
};

/**
 * Describes the message mj.protocol.v1.Aids.
 * Use `create(AidsSchema)` to create a new message.
 */
export const AidsSchema: GenMessage<Aids> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 4);

/**
 * @generated from message mj.protocol.v1.Hello
 */
export type Hello = Message<"mj.protocol.v1.Hello"> & {
  /**
   * @generated from field: string client_build = 1;
   */
  clientBuild: string;
};

/**
 * Describes the message mj.protocol.v1.Hello.
 * Use `create(HelloSchema)` to create a new message.
 */
export const HelloSchema: GenMessage<Hello> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 5);

/**
 * seated: a Resync follows for the account's running game; a finished game within the hour sends GameEndView.
 *
 * @generated from message mj.protocol.v1.Welcome
 */
export type Welcome = Message<"mj.protocol.v1.Welcome"> & {
  /**
   * @generated from field: bool seated = 1;
   */
  seated: boolean;
};

/**
 * Describes the message mj.protocol.v1.Welcome.
 * Use `create(WelcomeSchema)` to create a new message.
 */
export const WelcomeSchema: GenMessage<Welcome> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 6);

/**
 * @generated from message mj.protocol.v1.TableAssigned
 */
export type TableAssigned = Message<"mj.protocol.v1.TableAssigned"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: uint32 seat = 2;
   */
  seat: number;

  /**
   * public, stable player ids (never database ids), display names
   *
   * @generated from field: repeated mj.record.v1.Player players = 3;
   */
  players: Player[];

  /**
   * @generated from field: mj.record.v1.RulesRef rules = 4;
   */
  rules?: RulesRef | undefined;

  /**
   * canon(RulesRef) verbatim, so a 40-line verifier can hash it without the codec
   *
   * @generated from field: bytes rules_canon = 5;
   */
  rulesCanon: Uint8Array;

  /**
   * rated, queue_id, tier, clocks
   *
   * @generated from field: mj.record.v1.Table table = 6;
   */
  table?: Table | undefined;

  /**
   * canon(Table) verbatim, for the same reason
   *
   * @generated from field: bytes table_canon = 7;
   */
  tableCanon: Uint8Array;

  /**
   * per seat: its drawn tile lies sideways on top of its hand (design 10 T6); presentation
   *
   * @generated from field: repeated bool drawn_on_top = 8;
   */
  drawnOnTop: boolean[];
};

/**
 * Describes the message mj.protocol.v1.TableAssigned.
 * Use `create(TableAssignedSchema)` to create a new message.
 */
export const TableAssignedSchema: GenMessage<TableAssigned> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 7);

/**
 * Design 2 §3.2; sent to every seat before any nonce is accepted.
 *
 * @generated from message mj.protocol.v1.Commitment
 */
export type Commitment = Message<"mj.protocol.v1.Commitment"> & {
  /**
   * @generated from field: bytes commitment = 1;
   */
  commitment: Uint8Array;

  /**
   * @generated from field: uint64 commitment_time = 2;
   */
  commitmentTime: bigint;

  /**
   * @generated from field: bytes signature = 3;
   */
  signature: Uint8Array;

  /**
   * @generated from field: bytes key_id = 4;
   */
  keyId: Uint8Array;

  /**
   * player ids in seat order, exactly as hashed
   *
   * @generated from field: repeated string seating = 5;
   */
  seating: string[];

  /**
   * 10,000
   *
   * @generated from field: uint32 nonce_deadline_ms = 6;
   */
  nonceDeadlineMs: number;
};

/**
 * Describes the message mj.protocol.v1.Commitment.
 * Use `create(CommitmentSchema)` to create a new message.
 */
export const CommitmentSchema: GenMessage<Commitment> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 8);

/**
 * A fresh 16-byte nonce per commitment.
 *
 * @generated from message mj.protocol.v1.Nonce
 */
export type Nonce = Message<"mj.protocol.v1.Nonce"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: bytes commitment = 2;
   */
  commitment: Uint8Array;

  /**
   * @generated from field: bytes nonce = 3;
   */
  nonce: Uint8Array;
};

/**
 * Describes the message mj.protocol.v1.Nonce.
 * Use `create(NonceSchema)` to create a new message.
 */
export const NonceSchema: GenMessage<Nonce> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 9);

/**
 * The signature preimage includes the commitment (design 2 §3.2).
 *
 * @generated from message mj.protocol.v1.NonceReceipt
 */
export type NonceReceipt = Message<"mj.protocol.v1.NonceReceipt"> & {
  /**
   * @generated from field: bytes commitment = 1;
   */
  commitment: Uint8Array;

  /**
   * @generated from field: bytes signature = 2;
   */
  signature: Uint8Array;

  /**
   * @generated from field: bytes key_id = 3;
   */
  keyId: Uint8Array;
};

/**
 * Describes the message mj.protocol.v1.NonceReceipt.
 * Use `create(NonceReceiptSchema)` to create a new message.
 */
export const NonceReceiptSchema: GenMessage<NonceReceipt> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 10);

/**
 * @generated from message mj.protocol.v1.GameStart
 */
export type GameStart = Message<"mj.protocol.v1.GameStart"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;
};

/**
 * Describes the message mj.protocol.v1.GameStart.
 * Use `create(GameStartSchema)` to create a new message.
 */
export const GameStartSchema: GenMessage<GameStart> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 11);

/**
 * Seat view: own haipai only, wall empty.
 *
 * @generated from message mj.protocol.v1.HandStartView
 */
export type HandStartView = Message<"mj.protocol.v1.HandStartView"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: mj.record.v1.HandStart start = 2;
   */
  start?: HandStart | undefined;
};

/**
 * Describes the message mj.protocol.v1.HandStartView.
 * Use `create(HandStartViewSchema)` to create a new message.
 */
export const HandStartViewSchema: GenMessage<HandStartView> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 12);

/**
 * @generated from message mj.protocol.v1.Events
 */
export type Events = Message<"mj.protocol.v1.Events"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: uint32 hand_index = 2;
   */
  handIndex: number;

  /**
   * seat-view events in seq order, each exactly once; a window event appears only at its resolution
   *
   * @generated from field: repeated mj.record.v1.Event events = 3;
   */
  events: Event[];
};

/**
 * Describes the message mj.protocol.v1.Events.
 * Use `create(EventsSchema)` to create a new message.
 */
export const EventsSchema: GenMessage<Events> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 13);

/**
 * @generated from message mj.protocol.v1.Prompt
 */
export type Prompt = Message<"mj.protocol.v1.Prompt"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * SEAT-LOCAL counter, 1, 2, 3, …: reveals nothing about other seats' prompts
   *
   * @generated from field: uint32 prompt_id = 2;
   */
  promptId: number;

  /**
   * @generated from field: uint32 hand_index = 3;
   */
  handIndex: number;

  /**
   * the last event the client must have applied
   *
   * @generated from field: uint32 after_seq = 4;
   */
  afterSeq: number;

  /**
   * @generated from field: mj.protocol.v1.PromptKind kind = 5;
   */
  kind: PromptKind;

  /**
   * the seat's ActionSet from the core, by tile id; never empty
   *
   * @generated from field: repeated mj.record.v1.Action legal = 6;
   */
  legal: Action[];

  /**
   * at send time; the clock started when the subject event was sent
   *
   * @generated from field: uint32 base_ms_left = 7;
   */
  baseMsLeft: number;

  /**
   * @generated from field: uint32 bank_ms_left = 8;
   */
  bankMsLeft: number;

  /**
   * windows: so the client times its animation
   *
   * @generated from field: uint32 w_min_ms = 9;
   */
  wMinMs: number;
};

/**
 * Describes the message mj.protocol.v1.Prompt.
 * Use `create(PromptSchema)` to create a new message.
 */
export const PromptSchema: GenMessage<Prompt> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 14);

/**
 * @generated from message mj.protocol.v1.Act
 */
export type Act = Message<"mj.protocol.v1.Act"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: uint32 prompt_id = 2;
   */
  promptId: number;

  /**
   * @generated from field: mj.record.v1.Action action = 3;
   */
  action?: Action | undefined;

  /**
   * a discard's, as the client's hand shows it (design 8 §2); checked for range
   *
   * @generated from field: mj.record.v1.HandSlots slots = 4;
   */
  slots?: HandSlots | undefined;

  /**
   * a call's or kan's: the slots its tiles leave, as the hand shows it (design 10 T11)
   *
   * @generated from field: repeated uint32 call_slots = 5;
   */
  callSlots: number[];
};

/**
 * Describes the message mj.protocol.v1.Act.
 * Use `create(ActSchema)` to create a new message.
 */
export const ActSchema: GenMessage<Act> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 15);

/**
 * @generated from message mj.protocol.v1.Ack
 */
export type Ack = Message<"mj.protocol.v1.Ack"> & {
  /**
   * @generated from field: uint32 prompt_id = 1;
   */
  promptId: number;

  /**
   * @generated from field: mj.protocol.v1.AckStatus status = 2;
   */
  status: AckStatus;

  /**
   * @generated from field: uint32 bank_ms_left = 3;
   */
  bankMsLeft: number;
};

/**
 * Describes the message mj.protocol.v1.Ack.
 * Use `create(AckSchema)` to create a new message.
 */
export const AckSchema: GenMessage<Ack> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 16);

/**
 * PUBLIC: the seat whose turn it is, sent to every seat when its turn prompt is issued; never for a window.
 *
 * @generated from message mj.protocol.v1.Clock
 */
export type Clock = Message<"mj.protocol.v1.Clock"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: uint32 seat = 2;
   */
  seat: number;

  /**
   * @generated from field: uint32 base_ms_left = 3;
   */
  baseMsLeft: number;

  /**
   * @generated from field: uint32 bank_ms_left = 4;
   */
  bankMsLeft: number;
};

/**
 * Describes the message mj.protocol.v1.Clock.
 * Use `create(ClockSchema)` to create a new message.
 */
export const ClockSchema: GenMessage<Clock> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 17);

/**
 * Public, protocol-level; not in the record.
 *
 * @generated from message mj.protocol.v1.Connection
 */
export type Connection = Message<"mj.protocol.v1.Connection"> & {
  /**
   * @generated from field: uint32 seat = 1;
   */
  seat: number;

  /**
   * @generated from field: bool connected = 2;
   */
  connected: boolean;

  /**
   * @generated from field: bool auto = 3;
   */
  auto: boolean;
};

/**
 * Describes the message mj.protocol.v1.Connection.
 * Use `create(ConnectionSchema)` to create a new message.
 */
export const ConnectionSchema: GenMessage<Connection> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 18);

/**
 * Reveals are in the Win / ExhaustiveDraw events.
 *
 * @generated from message mj.protocol.v1.HandEndView
 */
export type HandEndView = Message<"mj.protocol.v1.HandEndView"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: mj.record.v1.HandEnd end = 2;
   */
  end?: HandEnd | undefined;
};

/**
 * Describes the message mj.protocol.v1.HandEndView.
 * Use `create(HandEndViewSchema)` to create a new message.
 */
export const HandEndViewSchema: GenMessage<HandEndView> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 19);

/**
 * @generated from message mj.protocol.v1.GameEndView
 */
export type GameEndView = Message<"mj.protocol.v1.GameEndView"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;

  /**
   * @generated from field: mj.record.v1.GameEnd end = 2;
   */
  end?: GameEnd | undefined;

  /**
   * @generated from field: bytes server_seed = 3;
   */
  serverSeed: Uint8Array;

  /**
   * @generated from field: repeated bytes player_nonces = 4;
   */
  playerNonces: Uint8Array[];

  /**
   * @generated from field: string record_url = 5;
   */
  recordUrl: string;
};

/**
 * Describes the message mj.protocol.v1.GameEndView.
 * Use `create(GameEndViewSchema)` to create a new message.
 */
export const GameEndViewSchema: GenMessage<GameEndView> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 20);

/**
 * @generated from message mj.protocol.v1.Resync
 */
export type Resync = Message<"mj.protocol.v1.Resync"> & {
  /**
   * @generated from field: mj.protocol.v1.TableAssigned table = 1;
   */
  table?: TableAssigned | undefined;

  /**
   * not sent: a snapshot of the core runs ahead of the release queue (an open window shows who could call; review 2026-10-10, F5). The client rebuilds from hand_start and events.
   *
   * @generated from field: bytes seat_view = 2;
   */
  seatView: Uint8Array;

  /**
   * the current hand
   *
   * @generated from field: mj.protocol.v1.HandStartView hand_start = 3;
   */
  handStart?: HandStartView | undefined;

  /**
   * between hands only: the end of the hand hand_start and events describe
   *
   * @generated from field: mj.protocol.v1.HandEndView previous_hand_end = 4;
   */
  previousHandEnd?: HandEndView | undefined;

  /**
   * the current hand's seat-view events (full, so the client can also rebuild from events)
   *
   * @generated from field: mj.protocol.v1.Events events = 5;
   */
  events?: Events | undefined;

  /**
   * the open prompt, with remaining times; absent if none
   *
   * @generated from field: mj.protocol.v1.Prompt prompt = 6;
   */
  prompt?: Prompt | undefined;

  /**
   * whose turn it is and their remaining time
   *
   * @generated from field: mj.protocol.v1.Clock clock = 7;
   */
  clock?: Clock | undefined;

  /**
   * @generated from field: repeated mj.protocol.v1.Connection connections = 8;
   */
  connections: Connection[];

  /**
   * as released so far (hand start, payments, hand end), never the core's own
   *
   * @generated from field: repeated int32 points = 9;
   */
  points: number[];

  /**
   * unranked tables: the seat's current aids
   *
   * @generated from field: mj.protocol.v1.Aids aids = 10;
   */
  aids?: Aids | undefined;
};

/**
 * Describes the message mj.protocol.v1.Resync.
 * Use `create(ResyncSchema)` to create a new message.
 */
export const ResyncSchema: GenMessage<Resync> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 21);

/**
 * @generated from message mj.protocol.v1.Error
 */
export type Error = Message<"mj.protocol.v1.Error"> & {
  /**
   * @generated from field: mj.protocol.v1.ErrorCode code = 1;
   */
  code: ErrorCode;

  /**
   * @generated from field: string detail = 2;
   */
  detail: string;
};

/**
 * Describes the message mj.protocol.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 22);

/**
 * @generated from message mj.protocol.v1.Ping
 */
export type Ping = Message<"mj.protocol.v1.Ping"> & {
  /**
   * @generated from field: uint64 t = 1;
   */
  t: bigint;
};

/**
 * Describes the message mj.protocol.v1.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 23);

/**
 * @generated from message mj.protocol.v1.Pong
 */
export type Pong = Message<"mj.protocol.v1.Pong"> & {
  /**
   * @generated from field: uint64 t = 1;
   */
  t: bigint;
};

/**
 * Describes the message mj.protocol.v1.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 24);

/**
 * @generated from message mj.protocol.v1.Leave
 */
export type Leave = Message<"mj.protocol.v1.Leave"> & {
  /**
   * @generated from field: string game_id = 1;
   */
  gameId: string;
};

/**
 * Describes the message mj.protocol.v1.Leave.
 * Use `create(LeaveSchema)` to create a new message.
 */
export const LeaveSchema: GenMessage<Leave> = /*@__PURE__*/
  messageDesc(file_mj_protocol_v1_protocol, 25);

/**
 * @generated from enum mj.protocol.v1.PromptKind
 */
export enum PromptKind {
  /**
   * @generated from enum value: PROMPT_UNSPECIFIED = 0;
   */
  PROMPT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AFTER_DRAW = 1;
   */
  AFTER_DRAW = 1,

  /**
   * @generated from enum value: RIICHI_DISCARD = 2;
   */
  RIICHI_DISCARD = 2,

  /**
   * @generated from enum value: AFTER_CLAIM = 3;
   */
  AFTER_CLAIM = 3,

  /**
   * @generated from enum value: WINDOW = 4;
   */
  WINDOW = 4,

  /**
   * @generated from enum value: PRE_DISCARD = 5;
   */
  PRE_DISCARD = 5,

  /**
   * @generated from enum value: LAST_TILE_OFFER = 6;
   */
  LAST_TILE_OFFER = 6,
}

/**
 * Describes the enum mj.protocol.v1.PromptKind.
 */
export const PromptKindSchema: GenEnum<PromptKind> = /*@__PURE__*/
  enumDesc(file_mj_protocol_v1_protocol, 0);

/**
 * @generated from enum mj.protocol.v1.AckStatus
 */
export enum AckStatus {
  /**
   * @generated from enum value: ACK_UNSPECIFIED = 0;
   */
  ACK_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * @generated from enum value: STALE_PROMPT = 2;
   */
  STALE_PROMPT = 2,

  /**
   * @generated from enum value: ILLEGAL = 3;
   */
  ILLEGAL = 3,

  /**
   * @generated from enum value: NOT_SEATED = 4;
   */
  NOT_SEATED = 4,
}

/**
 * Describes the enum mj.protocol.v1.AckStatus.
 */
export const AckStatusSchema: GenEnum<AckStatus> = /*@__PURE__*/
  enumDesc(file_mj_protocol_v1_protocol, 1);

/**
 * @generated from enum mj.protocol.v1.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_UNSPECIFIED = 0;
   */
  ERROR_UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPGRADE_REQUIRED = 1;
   */
  UPGRADE_REQUIRED = 1,

  /**
   * @generated from enum value: NOT_AUTHENTICATED = 2;
   */
  NOT_AUTHENTICATED = 2,

  /**
   * @generated from enum value: RATE_LIMITED = 3;
   */
  RATE_LIMITED = 3,

  /**
   * @generated from enum value: TABLE_DISSOLVED = 4;
   */
  TABLE_DISSOLVED = 4,

  /**
   * @generated from enum value: SUPERSEDED = 5;
   */
  SUPERSEDED = 5,

  /**
   * @generated from enum value: INTERNAL = 6;
   */
  INTERNAL = 6,

  /**
   * the gateway lost the game server: a running game cannot go on, and ends when it is back (design 4 §6.4)
   *
   * @generated from enum value: GAME_SERVER_DOWN = 7;
   */
  GAME_SERVER_DOWN = 7,
}

/**
 * Describes the enum mj.protocol.v1.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode> = /*@__PURE__*/
  enumDesc(file_mj_protocol_v1_protocol, 2);

